import { useTranslation } from 'react-i18next'
import { useToggleUserStatusMutation } from '@/entities/user'
import { getApiErrorText } from '@/shared/libs/get-api-error-text'
import { showToast } from '@/shared/libs/toast'
import { StatusToggleWithConfirm } from '@/shared/ui/status-toggle-with-confirm'

interface UserStatusToggleProps {
  userId: string
  isActive: boolean
}

export function UserStatusToggle({ userId, isActive }: UserStatusToggleProps) {
  const { t } = useTranslation()
  const toggleMutation = useToggleUserStatusMutation()

  async function handleConfirmed() {
    try {
      await toggleMutation.mutateAsync(userId)
      showToast.success(t('user.statusUpdateSuccess'))
    } catch (error) {
      showToast.error(getApiErrorText(error) ?? t('common.operationFailed'))
    }
  }

  return (
    <div className="flex justify-center">
      <StatusToggleWithConfirm
        checked={isActive}
        pending={toggleMutation.isPending}
        confirmEnableTitle={t('user.enableConfirm')}
        confirmDisableTitle={t('user.disableConfirm')}
        onConfirmed={handleConfirmed}
      />
    </div>
  )
}
